import {catchError, forkJoin, of} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {
  IAPIDalli,
  IAPISendEmail,
  IAPISendEmailContacts,
  IGetTariff,
  IGetTracking,
  IGetYmap,
  IReduxSendEmail,
  IReduxSendEmailContacts,
} from './Interfaces';
import SliderStoriesStoryStub from '../../components/Stories/SliderStoriesStoryHead/StoriesReactHead';
import {GetNameTitle} from './GlobalFunctions';
import {EnumUrlsPages} from '../../services/Enum';
import {IArticle} from '../../pages/PageArticle/interfaces';
import {IReduxWordpressAll} from './InterfacesRedux';
import {IStory} from '../../components/Stories/SliderStoriesGroup/interfaces';
import {APIYmaps} from './APIRequestsYmaps';
import {APIWordpress} from "./APIRequestsWordpress";
import {IWordpressArticle, IWordpressArticleLocation} from "./InterfacesWordpress";
import {StubTrackingInfo} from "../../pages/PageTracking/constants";
import {DKT, GetUtmFromCookie, GetUtmFromSavedInCookie} from "./AmoCRM/Functions";

class ServiceRedux {
  //--------------------- static
  getHeader = ({headerLoaded}: any) => {
    headerLoaded({
      menu: [
        {link: EnumUrlsPages.about, text: 'Команда Dalli'},
        {link: EnumUrlsPages.delivery, text: 'Доставка по России'},
        {link: EnumUrlsPages.live, text: 'Live'},
        {link: EnumUrlsPages.questions, text: 'Частые вопросы'},
        {link: EnumUrlsPages.docs, text: 'Документы'},
        {link: EnumUrlsPages.reviews, text: 'Отзывы'},
        {link: EnumUrlsPages.clients, text: 'Наши клиенты'},
        {link: EnumUrlsPages.cashService, text: 'Кассовое обслуживание'},
        {link: EnumUrlsPages.returnDocuments, text: 'Возврат документов'},
        {link: EnumUrlsPages.deliveryLogistics, text: 'Логистика '},
        {link: EnumUrlsPages.gallery, text: 'Фотогалерея'},
        {link: EnumUrlsPages.deliveryMsk, text: 'Доставка по Москве и МО'},
        {link: EnumUrlsPages.deliveryMskToSpb, text: 'Доставка из Москвы в СПб и ЛО'},
        {link: EnumUrlsPages.deliverySpb, text: 'Доставка по Санкт-Петербургу'},
        {link: EnumUrlsPages.deliverySameDay, text: 'Доставка день в день'},
        {link: EnumUrlsPages.deliveryNextDay, text: 'Доставка на следующий день'},
        {link: EnumUrlsPages.deliveryShipFromStore, text: 'Доставка для оффлайн магазинов'},
        {link: EnumUrlsPages.deliveryPVZ, text: 'Пункты самовывоза'},
        {link: EnumUrlsPages.deliveryOutsourcing, text: 'Аутсорсинг доставки'},
        {link: EnumUrlsPages.deliveryComprehensiveService, text: 'Комплексное обслуживание'},
      ],
    });
  };

  getYmaps = ({func, alertLoaded}: IGetYmap) => {
    APIYmaps.getYmaps()
      .pipe(tap(func), catchError(PrintAlertError(alertLoaded)))
      .subscribe();
  };

  /* --- API DALLI ------------------------------------------------------------- */

  getUtmFields = () => {
    const utmParams = new URLSearchParams(window.location.search);
    const { source, medium, campaign, content, term } = GetUtmFromSavedInCookie();
    const { utm_source, utm_medium, utm_campaign, utm_content, utm_term } = GetUtmFromCookie();

    const result: {[key: string]: any} = {
      saved_utm_source: utmParams.get('utm_source') || source || utm_source || '(none)',
      saved_utm_medium: utmParams.get('utm_medium') || medium || utm_medium || '(none)',
      saved_utm_campaign: utmParams.get('utm_campaign') || campaign || utm_campaign || '(none)',
      saved_utm_content: utmParams.get('utm_content') || content || utm_content || '(none)',
      saved_utm_term: utmParams.get('utm_term') || term || utm_term || '(none)',
      saved_dkt_source: DKT([utmParams.get('utm_source'), source, utm_source]),
      saved_dkt_medium: DKT([utmParams.get('utm_medium'), medium, utm_medium]),
      saved_dkt_campaign: DKT([utmParams.get('utm_campaign'), campaign, utm_campaign]),
      saved_dkt_content: DKT([utmParams.get('utm_content'), content, utm_content]),
      saved_dkt_term: DKT([utmParams.get('utm_term'), term, utm_term])
    };

    return result;
  }

  // Единый разбор ответа Contact Form 7 REST.
  handleCf7Response = (response: any, success: Function, setServerText?: Function) => {
    const responseData = response && response.data;
    if (!responseData) {
      success();
      return;
    }
    switch (responseData.status) {
      case 'mail_sent':
        success();
        break;
      case 'spam':
        // Серверная проверка капчи (или другой спам-фильтр) отклонила заявку.
        if (setServerText) {
          setServerText('Проверка не пройдена. Попробуйте отправить ещё раз.');
        }
        console.error('Form submission blocked as spam:', responseData);
        break;
      case 'validation_failed': {
        const errorMessages = responseData.invalid_fields && responseData.invalid_fields.length > 0
          ? responseData.invalid_fields.map((field: any) => field.message).join(', ')
          : '';
        if (setServerText) {
          setServerText(errorMessages || responseData.message || 'Ошибка валидации формы');
        }
        console.error('Form validation failed:', responseData);
        break;
      }
      default:
        if (setServerText) {
          setServerText(responseData.message || 'Произошла ошибка при отправке формы');
        }
        console.error('Form submission error:', responseData);
    }
  };

  submitForm = ({
                 data,
                 eventMetrika,
                 contactFormId = null,
                 token = '',
                 success,
                 setServerText
               }: IReduxSendEmail) => {
    const {origin, pathname} = window.location;
    let dataSend: any = {
      ...data,
      url: `${origin}${pathname}`,
      page: GetNameTitle({eventMetrika}),
      title: GetNameTitle({eventMetrika}),
      ...this.getUtmFields()
    };

    if (contactFormId) {
      APIWordpress.sendForm(contactFormId, dataSend, token)
        .then((response) => this.handleCf7Response(response, success, setServerText))
        .catch(e => {
          console.error('error form submission', e);
          if (setServerText) {
            setServerText('Произошла ошибка при отправке формы');
          }
        });
    } else {
      alert('Заявка не была отправлена по техническим причинам :(');
    }

  };

  sendEmailContacts = ({
                         data,
                         token = '',
                         success,
                         eventMetrika,
                         contactFormId,
                         setServerText
                       }: IReduxSendEmailContacts) => {
    const {origin, pathname} = window.location;

    let dataSend: IAPISendEmailContacts = {
      ...data,
      url: `${origin}${pathname}`,
      page: data.page ? data.page : GetNameTitle({eventMetrika}),
      ...this.getUtmFields()
    };

    if (contactFormId) {
      APIWordpress.sendForm(contactFormId, dataSend, token)
        .then((response) => this.handleCf7Response(response, success, setServerText))
        .catch(e => {
          console.error('error form submission', e);
          if (setServerText) {
            setServerText('Произошла ошибка при отправке формы');
          }
        });
    } else {
      alert('Заявка не была отправлена по техническим причинам :(');
    }
  };

  getTariffMsc = ({data, calculatorLoaded, alertLoaded, success}: IGetTariff) => {
    forkJoin([
      APIWordpress.getTariff({typedelivery: 'KUR', partner: 'DS', ...data}),
      APIWordpress.getTariff({typedelivery: 'KUR', partner: 'SDEK', ...data}),
      APIWordpress.getTariff({typedelivery: 'PVZ', partner: 'BOXBERRY', ...data}),
      APIWordpress.getTariff({typedelivery: 'PVZ', partner: 'SDEK', ...data}),
      APIWordpress.getTariff({typedelivery: 'PVZ', partner: '5POST', ...data}),
      APIWordpress.getTariff({output: 'x2', partner: 'RUPOST', ...data}),
    ])
      .pipe(
        tap(
          ([KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost]: [
            IAPIDalli,
            IAPIDalli,
            IAPIDalli,
            IAPIDalli,
            IAPIDalli,
            IAPIDalli
          ]) => {
            calculatorLoaded({KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost});
            alertLoaded([]);
          }
        ),
        finalize(success),
        catchError(PrintAlertError(alertLoaded))
      )
      .subscribe();
  };

  getTariffSpb = ({data, calculatorLoaded, alertLoaded, success}: IGetTariff) => {
    forkJoin([
      APIWordpress.getTariff({typedelivery: 'KUR', partner: 'DS', ...data}),
      APIWordpress.getTariff({typedelivery: 'KUR', partner: 'SDEK', ...data}),
      APIWordpress.getTariff({typedelivery: 'PVZ', partner: 'BOXBERRY', ...data}),
      APIWordpress.getTariff({typedelivery: 'PVZ', partner: 'SDEK', ...data}),
    ])
      .pipe(
        tap(([KurDalli, KurSdek, PvzBoxberry, PvzSdek]: [IAPIDalli, IAPIDalli, IAPIDalli, IAPIDalli]) => {
          calculatorLoaded({
            KurDalli,
            KurSdek,
            PvzBoxberry,
            PvzSdek,
            Pvz5post: {error: '123', errormsg: 'Нет 5post'},
            RuPost: {error: '123', errormsg: 'Нет 5post'},
          });
          alertLoaded([]);
        }),
        finalize(success),
        catchError(PrintAlertError(alertLoaded))
      )
      .subscribe();
  };

  tracking = ({track, phone, setHistory, setServerText, success}: IGetTracking) => {
    APIWordpress.tracking({track, phone}).then((data) => {
      if (data.errormsg) {
        setHistory(StubTrackingInfo);
        setServerText(data.errormsg);
      } else {
        setHistory(data.tracking);
        setServerText('');
      }
      success();
    }).catch(err => setServerText(err));
  };

  articleMapper = (article: IWordpressArticle): IArticle => {
    return {
      title: article.title,
      id: article.id,
      image: article.image,
      imageStretchy: article.image_stretchy,
      imageFullwidth: article.image_fullwidth,
      type: article.blog_type,
      uri: article.uri,
      link: article.uri,
      alias: article.alias,
      date: article.date,
      content: article.content_text,
      isMain: article.location?.includes(IWordpressArticleLocation.main) || false,
      isPopular: article.location?.includes(IWordpressArticleLocation.popular) || false
    }
  };

  getBlog = async () => {
    const data = await APIWordpress.getBlog();
    const allArticles: IArticle[] = data.articles.map((a, i) => this.articleMapper({
      ...a,
      id: a.id || String(i + 1)
    }));
    const main = allArticles.filter(a => a.isMain);
    const popular = allArticles.filter(a => a.isPopular);
    return {
      all: allArticles,
      main,
      popular
    }
  }

  getBlogMain = async() => {
    const data = await APIWordpress.getBlogMain();
    console.log('data', data);
    return data.articles.map((a, i) => this.articleMapper({
      ...a,
      id: a.id || String(i + 1)
    }));
  }

  getAll = async (callbacks: IReduxWordpressAll = {alertLoaded: console.log}) => {
    try {
      const data = await APIWordpress.getAll();
      if (callbacks.storiesLoaded) {
        const stories: IStory[] = [];
        data.stories.items.forEach((story, i) => {
          stories.push({
            id: String(i + 1),
            image: story.image,
            name: story.title,
            slides: story.slides ? story.slides.map(slide => ({
              type: slide.type,
              url: slide.url,
              header: <SliderStoriesStoryStub name={story.title} url={`${story.image}`}/>,
              duration: 5000
            })) : []
          });
        });
        callbacks.storiesLoaded(stories);
      }
      if (callbacks.vacanciesLoaded) {
        callbacks.vacanciesLoaded(data.vacancies.items.map((v, i) => ({...v, id: i + 1})));
      }
      if (callbacks.advantagesSliderLoaded) {
        callbacks.advantagesSliderLoaded(data.advantage_slider);
      }
      if (data.company_logos) {
        if (callbacks.logosPartnersLoaded) {
          callbacks.logosPartnersLoaded(data.company_logos.items);
        }
      }
      if (data.reviews) {
        if (callbacks.reviewsLoaded) {
          callbacks.reviewsLoaded(data.reviews.items);
        }
      }
      if (callbacks.aboutLoaded) {
        callbacks.aboutLoaded({
          pageVacancies: {
            image: data.vacancies.image,
            title: data.vacancies.title,
            subTitle: data.vacancies.subtitle
          }
        });
      }
      if (callbacks.state404Loaded) {
        // todo
      }
      if (callbacks.blockedSendLoaded) {
        // todo
      }
      if (callbacks.textCardsLoaded) {
        callbacks.textCardsLoaded(data.text_cards);
      }
      if (callbacks.iconCardsLoaded) {
        callbacks.iconCardsLoaded(data.icon_cards);
      }
      if (callbacks.contactFormsLoaded) {
        callbacks.contactFormsLoaded(data.contact_forms);
      }
    } catch (e) {
      if (callbacks.alertLoaded) {
        PrintAlertError(callbacks.alertLoaded)(e);
      } else {
        console.error('alert loaded is not defined');
        console.error(e);
      }
    }
  }

  /* ------------------------------------------------------------ */
}

export const ServiceData = new ServiceRedux();

export const PrintAlertError = (alertLoaded: any) => (err: any) => {
  if (err.response) {
    switch (err.response.status) {
      case 400:
      case 401:
        alertLoaded(err.response.data.message);
        break;
      case 404:
        alertLoaded('');
        break;
      default:
        alertLoaded(err.response.data.message);
    }
  } else {
    console.error(err);
    // alertLoaded([err]);
  }
  return of(err);
};
